// ---------------------------------------------------------------
// Skeleton.js — Siluetas de carga (en vez del círculo girando).
// Son sólo divs con CSS: no descargan nada ni consumen CPU
// apreciable, así que no ralentizan móviles modestos.
// ---------------------------------------------------------------

/** Silueta de una sección: unas tarjetas de métricas + una lista */
export function SectionSkeleton() {
  return (
    <div aria-busy="true" aria-label="Cargando">
      <div className="sk-grid">
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="sk-card">
            <div className="sk sk-avatar" style={{ borderRadius: 12 }} />
            <div className="sk sk-line lg" style={{ marginTop: 14 }} />
            <div className="sk sk-line sm" />
          </div>
        ))}
      </div>
      <div className="sk-card">
        <div className="sk sk-line lg" />
        <div className="sk sk-line sm" style={{ marginBottom: 18 }} />
        {[0, 1, 2, 3].map((i) => (
          <div key={i} className="sk-row">
            <div className="sk sk-avatar" />
            <div className="sk-row-text">
              <div className="sk sk-line" style={{ width: "42%" }} />
              <div className="sk sk-line sm" style={{ marginBottom: 0 }} />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}

/** Silueta de una lista dentro de una tarjeta ya existente */
export function ListSkeleton({ rows = 4 }) {
  return (
    <div aria-busy="true" aria-label="Cargando">
      {Array.from({ length: rows }, (_, i) => (
        <div key={i} className="sk-row">
          <div className="sk sk-avatar" />
          <div className="sk-row-text">
            <div className="sk sk-line" style={{ width: "38%" }} />
            <div className="sk sk-line sm" style={{ marginBottom: 0 }} />
          </div>
        </div>
      ))}
    </div>
  );
}
